import { api } from "..";

const endpoint = "/api/accounts-payable";

export const getApFlow = (queryParams) => {
  return api.get(`${endpoint}/flow`, { params: queryParams });
};
